export class LogIn {
    public email: string;
    public password: string;
    public isRememberMe: boolean = true;
}
